import { enums as highlights } from '~/patterns/VehicleHighlight/Highlights'

const highlightsIcons = highlights.reduce((icons, icon) => {
  try {
    icons[icon] = require(`./${icon}.svg`).default
  } catch (error) {
    // ignore non-existing files
    console.log('Icon not found: ', icon)
  }
  return icons
}, {})

export default highlightsIcons
